import React from "react";

import TourRunner from "../base/TourRunner";

import { frequenciesTourConfiguration } from "./configuration";

const FrequenciesTour = () => {
  return <TourRunner descriptor={frequenciesTourConfiguration} />;
};

export default FrequenciesTour;
